import React from 'react';
import PropTypes from 'prop-types';

import {
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS,
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED,
} from 'common/applicationAssemblyLineConstants';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrErrorMessage, {
  SR_ERROR_MESSAGE_THEME_ORANGE,
} from 'client/components/SrErrorMessage/SrErrorMessage';
import {
  SR_COLLAPSIBLE_CONTAINER_BORDER_TYPE_ROUNDED,
} from 'client/components/SrCollapsibleContainer/SrCollapsibleContainer';
import SrApplicationAssemblyLineContainer from 'client/components/SrApplicationAssemblyLine/SrApplicationAssemblyLineContainer';

const SrApplicationAssemblyLineStepDependents = ({ householdApplication }) => (
  <div>
    {householdApplication.children.length === 0 || householdApplication.childrenCount === 0
      ? (
        <SrText
          color='blueGreycliff'
          font='greycliff'
          weight='600'
          size='16'
          lineHeight='24px'
        >
          Applicant has no dependents.
        </SrText>
      )
      : householdApplication.children.map((child) => (
        <SrBox key={child.name} marginBottom='24px'>
          <SrApplicationAssemblyLineContainer
            title={`${child.name} (${child.age})`}
            titleColor={child.age < 18 ? 'green' : 'orange300'}
            isExpanded={false}
            notExpandible
            status={child.age < 18
              ? SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED
              : SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS}
            borderType={SR_COLLAPSIBLE_CONTAINER_BORDER_TYPE_ROUNDED}
          />
          {child.age >= 18 && (
            <SrBox marginTop='22px'>
              <SrText
                color='orange300'
                font='greycliff'
                weight='700'
                size='18'
                lineHeight='24px'
                display='block'
              >
                Information Required
              </SrText>
              <SrBox marginTop='8px' maxWidth='468px'>
                <SrErrorMessage theme={SR_ERROR_MESSAGE_THEME_ORANGE}>
                  Dependents Listed
                  <br />
                  Please ask the Applicant to have anyone 18 or older fill out their own application.
                </SrErrorMessage>
                <SrBox marginTop='16px' />
              </SrBox>
            </SrBox>
          )}
        </SrBox>
      ))
    }
  </div>
);

SrApplicationAssemblyLineStepDependents.propTypes = {
  householdApplication: PropTypes.object.isRequired,
};

SrApplicationAssemblyLineStepDependents.stepTitle = 'Dependents';
SrApplicationAssemblyLineStepDependents.displayName = 'SrApplicationAssemblyLineStepDependents';

SrApplicationAssemblyLineStepDependents.getStatus = ({ householdApplication }) => {
  if (householdApplication.children.every((child) => child.age < 18)) {
    return SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED;
  }

  return SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS;
};

export default SrApplicationAssemblyLineStepDependents;
